<template>
  <svg
    width="10"
    height="12"
    viewBox="0 0 10 12"
  >
    <path d="M1.00029 2.08525L1 8.5C1 9.82548 2.03154 10.91 3.33562 10.9947L3.5 11L7.9144 11.0007C7.70828 11.5829 7.15285 12 6.5 12H3C1.34315 12 0 10.6569 0 9V3.5C0 2.84678 0.417543 2.29109 1.00029 2.08525ZM8.5 0C9.32843 0 10 0.671573 10 1.5V8.5C10 9.32843 9.32843 10 8.5 10H3.5C2.67157 10 2 9.32843 2 8.5V1.5C2 0.671573 2.67157 0 3.5 0H8.5ZM8.5 1H3.5C3.22386 1 3 1.22386 3 1.5V8.5C3 8.77614 3.22386 9 3.5 9H8.5C8.77614 9 9 8.77614 9 8.5V1.5C9 1.22386 8.77614 1 8.5 1Z" />
  </svg>
</template>
